<template>
  <div style='height: 100%'>
    <div class='hbox'>
      <img v-if='userHeadPortraitUrl' @click='showUploadHeadPortraitImgMD' :src='userHeadPortraitUrl' class='headImg'/>
      <img v-else src='/images/back/headPortrait.png' class='headImg' @click='showUploadHeadPortraitImgMD'/>
    </div>
    <div class='vbox userDiv'>
      <!-- <span class='userSpan'>{{userCode}} ({{userName}})</span> -->
      <span class='userSpan'>
        <el-button type='primary' size='mini' @click='showChangePasswordDialogMD' style='width: 120px;'>修改密码</el-button>
      </span>
      <span class='userSpan'>
        <el-button type='danger' size='mini' @click='logout' style='width: 120px;'>退出登录</el-button>
      </span>
    </div>

    <!-- 选择头像文件弹出框 -->
    <el-dialog v-dialogDrag :visible.sync='showUploadHeadPortraitImg' title='选择头像'
      width='290px' top='10px' lock-scroll append-to-body>
      <el-upload action='' style='margin-top: -35px;'
        :before-upload='uploadHeadPortraitImg'
        accept='image/png,image/jpeg,image/gif'
        class='avatar-uploader'
        :show-file-list='false'>
        <img v-if='tempHeadPortraitUrl' :src='tempHeadPortraitUrl' class='avatar'>
        <i v-else class='el-icon-plus avatar-uploader-icon'></i>
      </el-upload>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='saveHeadPortraitUrl()' size='mini'>保存</el-button>
        <el-button @click='showUploadHeadPortraitImg = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <!-- 修改密码弹出框 -->
    <el-dialog v-dialogDrag title='修改密码' :visible.sync='showChangePasswordDialog' width='300px' :append-to-body='true'
      top='20vh' lock-scroll>
      <el-form :model='passwordInfo' label-width='80px' style='margin-top: -30px;'
        label-position='right' size='mini'>
        <div class='hbox'>
          <el-form-item label='密码 ' prop='password' class='formRow'>
            <el-input type='password' v-model='passwordInfo.password' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='确认密码 ' prop='rptPassword' class='formRow'>
            <el-input type='password' v-model='passwordInfo.rptPassword' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='dialogButtomBtn' style='margin-top: -5px;'>
          <el-button type='primary' @click='changePwd()' size='mini'>确定</el-button>
          <el-button @click='showChangePasswordDialog = false' size='mini'>取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import userInfoUtil from '@/utils/userInfoUtil'
import axios from 'axios'
import axiosHelper from '@/utils/axiosHelper'
import { Loading } from 'element-ui'
import cookieHelper from '@/utils/cookieHelper'

export default {
  name: 'Personal',
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      userCode: '',
      userName: '',
      headPortraitUrl: '',
      userHeadPortraitUrl: '',
      tempHeadPortraitUrl: '',

      showUploadHeadPortraitImg: false,

      showChangePasswordDialog: false,
      passwordInfo: {
        password: '',
        rptPassword: ''
      }
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    that.userCode = userInfoUtil.getUserCode()
    that.userName = userInfoUtil.getUserName()
    that.userHeadPortraitUrl = userInfoUtil.getUserHeadPortraitUrl()
    const headPortraitUrlPromise = userInfoUtil.getHeadPortraitUrl()
    that.headPortraitUrl = await headPortraitUrlPromise
  },

  methods: {
    // 头像选择弹出框显示方法
    showUploadHeadPortraitImgMD: function () {
      const that = this
      that.showUploadHeadPortraitImg = true
      that.tempHeadPortraitUrl = ''
    },

    // 上传头像图片
    uploadHeadPortraitImg: function (file) {
      const that = this
      const imgTest = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/
      if (!imgTest.test(file.name)) {
        that.$message.warning('只能选择图片！')
        return false
      }
      if (file.size / 1024 / 1024 > 5) {
        that.$message.warning('图片大小不能超过5M！')
        return false
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const formData = new FormData()
      formData.append('file', file)
      axios({
        method: 'post',
        url: '/WebSYSFileUpload/User.UploadHeadPortraitUrl',
        headers: {
          'Content-Type': 'multipart/form-data;charset=UTF-8'
        },
        data: formData
      }).then(function (response) {
        if (response.data && response.data.error === '000000') {
          that.tempHeadPortraitUrl = response.data.url
          loadingInstance.close()
          return false
        } else {
          that.$message.error('网络请求失败！')
          loadingInstance.close()
          return false
        }
      }).catch(function () {
        that.$message.error('网络请求失败！')
        loadingInstance.close()
        return false
      })
    },

    // 保存用户头像
    saveHeadPortraitUrl: async function () {
      const that = this
      if (!that.tempHeadPortraitUrl) {
        that.$message.error('请选择图片')
        return false
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/User.UpdateHeadPortraitUrl', {
        url: that.tempHeadPortraitUrl
      })
      if (rtnObj.error === '000000') {
        that.showUploadHeadPortraitImg = false
        const userInfoJson = cookieHelper.getCookie('userInfo')
        if (userInfoJson) {
          const userInfo = JSON.parse(decodeURI(userInfoJson))
          userInfo.HeadPortraitUrl = rtnObj.url
          cookieHelper.setCookie('userInfo', JSON.stringify(userInfo), 1)
          that.$store.dispatch('commitUserInfo', userInfo)
        }
        that.userHeadPortraitUrl = rtnObj.url
        that.$message.success('保存成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 退出登录
    logout: async function () {
      const that = this
      const rtnObj = await axiosHelper.handle('/WebSYSAction/User.Logout', {})
      console.log(rtnObj)
      if (rtnObj && rtnObj.error === '000000') {
        const uri = location.toString()
        location.replace(uri.substring(0, uri.indexOf('#')))
      } else {
        that.$message.error(rtnObj.msg)
      }
    },

    // 修改密码弹出框显示方法
    showChangePasswordDialogMD: function () {
      const that = this
      that.showChangePasswordDialog = true
    },

    // 修改密码
    changePwd: async function () {
      const that = this
      if (!that.passwordInfo.password) {
        that.$message.error('请输入密码！')
        return
      }
      if (that.passwordInfo.rptPassword !== that.passwordInfo.password) {
        that.$message.error('确认密码必须和密码相同！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/User.UpdatePsd', {
        password: that.passwordInfo.password
      })

      if (rtnObj.error === '000000') {
        const uri = location.toString()
        that.showChangePasswordDialog = false
        location.replace(uri.substring(0, uri.indexOf('#')))
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }
  }
}
</script>

<style scope>
.vbox {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.hbox {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.headImg {
  margin-top: 10px;
  height: 200px;
  width: 200px;
  border-radius: 100px;
}
.userDiv {
  margin-top: 10px;
}
.userSpan {
  padding-top: 20px;
  color: #A8A8A8;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 250px;
  height: 250px;
  line-height: 250px;
  text-align: center;
}
.avatar {
  width: 250px;
  height: 250px;
  display: block;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.formRow {
  margin-top: 2px;
  margin-bottom: 3px;
}
.dialogButtomBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: -10px;
}
</style>
